import { render, staticRenderFns } from "./waterMaster05Detail.vue?vue&type=template&id=72b7c9a0"
import script from "./waterMaster05Detail.vue?vue&type=script&lang=js"
export * from "./waterMaster05Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b7c9a0')) {
      api.createRecord('72b7c9a0', component.options)
    } else {
      api.reload('72b7c9a0', component.options)
    }
    module.hot.accept("./waterMaster05Detail.vue?vue&type=template&id=72b7c9a0", function () {
      api.rerender('72b7c9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/mst/waterMaster05Detail.vue"
export default component.exports